import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";

export const onboardingStateSelector = (state: RootState) => state.onboarding;

export const onboardingSelectors = {
  isLoading: createSelector(onboardingStateSelector, s => s.isLoading),
  isError: createSelector(onboardingStateSelector, s => s.isError),
  errorCode: createSelector(onboardingStateSelector, s => s.errorCode),
  isSuccess: createSelector(onboardingStateSelector, s => s.isSuccess),
  isUninitialized: createSelector(
    onboardingStateSelector,
    s => s.isUninitialized,
  ),
  error: createSelector(onboardingStateSelector, s => s.error),
  data: createSelector(onboardingStateSelector, s => s.data),
  stepValues: createSelector(onboardingStateSelector, s => s.stepValues),
  lastAction: createSelector(onboardingStateSelector, s => s.lastAction),
  currentStep: createSelector(onboardingStateSelector, s => s.currentStep),
  redirectError: createSelector(onboardingStateSelector, s => s.redirectError),
};
